
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linga-bhairavi/[region]/[lang]/visit-devi",
      function () {
        return require("private-next-pages/linga-bhairavi/[region]/[lang]/visit-devi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/linga-bhairavi/[region]/[lang]/visit-devi"])
      });
    }
  